import { useQuery } from "react-query"
import FormService from "~services/FormService"

const useDynamicForm = (id: string) => {
  return useQuery(["form", id], () => FormService.getFormById(id), {
    enabled: false,
  })
}

export default useDynamicForm
